import { analysisConfigModuleReducer } from '@ane/analysis-config-app-module/lib/module/reducers';
import { selectExperimentationGroupsReducersMapObject } from '@ane/exp-ux/lib/components/SelectExperimentationGroup/LoadExperimentationGroups.ducks';
// Isolation groups
import { moduleReducer as isolationGroupsReducer } from '@ane/isolation-group-app-module/lib/module/reducers';
/**
 * Create an object that can simply be merged with the exp-ui reducer { ...reducers, ...analysisReducer }
 * this will map to state.analysis[branch]
 */
//: ReducersMapObject<IModuleState, any>
export const moduleReducer = Object.assign(Object.assign(Object.assign({}, analysisConfigModuleReducer), selectExperimentationGroupsReducersMapObject), isolationGroupsReducer);
export default moduleReducer;

//# sourceMappingURL=reducers.js.map
